import { GUEST_SIGN_IN_ID_ALPHABET, GUEST_SIGN_IN_ID_GROUP_LENGTH, GUEST_SIGN_IN_ID_GROUPS, } from "../constants/auth.js";
const ID_LENGTH = GUEST_SIGN_IN_ID_GROUPS * GUEST_SIGN_IN_ID_GROUP_LENGTH;
/** Upper-cases a typed guest ID and drops spaces, dashes and anything else that isn't a letter or digit. */
export function normalizeGuestSignInId(raw) {
    return raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
}
export function isValidGuestSignInId(raw) {
    const id = normalizeGuestSignInId(raw);
    return id.length === ID_LENGTH && [...id].every((c) => GUEST_SIGN_IN_ID_ALPHABET.includes(c));
}
/** Splits a normalized guest ID into dash-separated groups for display, e.g. `ABCDE-FGHJK-MNPQR-STUVW`. */
export function formatGuestSignInId(raw) {
    const id = normalizeGuestSignInId(raw);
    const groups = [];
    for (let i = 0; i < id.length; i += GUEST_SIGN_IN_ID_GROUP_LENGTH) {
        groups.push(id.slice(i, i + GUEST_SIGN_IN_ID_GROUP_LENGTH));
    }
    return groups.join("-");
}
/**
 * A new normalized guest ID. `randomIndex(n)` must return a uniformly random
 * integer in `[0, n)` from a cryptographically secure source.
 */
export function generateGuestSignInId(randomIndex) {
    let id = "";
    for (let i = 0; i < ID_LENGTH; i++) {
        id += GUEST_SIGN_IN_ID_ALPHABET[randomIndex(GUEST_SIGN_IN_ID_ALPHABET.length)];
    }
    return id;
}
//# sourceMappingURL=guestSignInId.js.map